// /set-up API
//  - POST /set-up/install-local-car  -> install embedded root CA (admin perms)
//  - GET  /set-up/is-up              -> liveness

export class SetupAPI {
  /** @param {import('../httpClient').HttpClient} http */
  constructor(http) {
    this.http = http;
  }

  installLocalCAR() {
    return this.http.post("/set-up/install-local-car");
  }

  isUp() {
    return this.http.get("/set-up/is-up");
  }
}
